import { useCallback } from 'react';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { useSSEStream } from '@teetsh/app/src/hooks/useSSEStream';

interface Props {
  livretEleveId: string;
  matiereId?: string;
  onComplete: () => void;
}

export function useGenerateRemark(props: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const requestURL = `/v0/schoolyears/${schoolyear.id}/schools/${school.id}/livrets-eleves/${props.livretEleveId}/remark-suggestion`;

  const { data, error, isLoading, startStream, stopStream, reset } =
    useSSEStream(requestURL, {
      onComplete: () => props.onComplete(),
    });

  const startGeneration = useCallback(() => {
    const body: Record<string, any> = {
      stream: true,
    };

    if (props.matiereId) {
      body.matiereId = props.matiereId;
    }

    startStream(body);
  }, [startStream, props.matiereId]);

  return {
    data,
    error,
    isLoading,
    stop: stopStream,
    startGeneration,
    reset,
  };
}
